module.exports = __webpack_public_path__ + "img/1.08ee4322.jpg";